export const AFTER_PASSWORD_RESET_SIGN_UP_REDIRECT_URL_STORAGE_KEY =
  'after_password_reset_sign_up_redirect_url';
